// AddButton component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import IconButton from '../icon_button/icon_button.jsx'

class AddButton extends Component {
  constructor (props) {
    super(props)

    this.state = {
      bShowClose: false,
      active: !this.props.hidden,
      animate: this.props.animate,
      size: this.props.size
    }
  }

  static get propTypes () {
    return {
      title: PropTypes.string,
      onClick: PropTypes.func,
      onCloseClick: PropTypes.func,
      bShowClose: PropTypes.bool,
      className: PropTypes.string,
      hidden: PropTypes.bool,
      animate: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      title: '',
      onClick: null,
      onCloseClick: null,
      bShowClose: false,
      className: '',
      hidden: false,
      size: 'big'
    }
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps (nextProps) {
    if (nextProps.bShowClose !== this.state.bShowClose) {
      this.setState({ bShowClose: nextProps.bShowClose })
    } else if (nextProps.hidden !== this.props.hidden) {
      this.setState({ active: !nextProps.hidden })
    }
  }

  show () {
    this.setState({ active: true, animate: false })
  }

  hide () {
    this.setState({ active: false, animate: false })
  }

  showCloseAdd () {
    this.setState({ bShowClose: true, animate: false })
  }

  hideCloseAdd () {
    this.setState({ bShowClose: false, animate: false })
  }

  render () {
    const { title, onClick, onCloseClick, size } = this.props
    const _className = classnames(
      'addbutton',
      {
        addclose: this.state.bShowClose,
        animate: this.state.animate,
        inactive: !this.state.active
      },
      this.props.className
    )
    const onIconClick = this.state.bShowClose ? onCloseClick : onClick

    return (
      <IconButton
        className={_className}
        onClick={onIconClick}
        title={title}
        size={size}
        canHover={false}
      >
        <span className='hline' />
        <span className='vline' />
      </IconButton>
    )
  }
}

export default AddButton
